import React from 'react';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'Julieta',
    age: 28,
    city: 'CABA',
    img: 'https://randomuser.me/api/portraits/women/17.jpg',
    text: 'Siempre volvía a escribirle, era más fuerte que yo. Este libro me hizo ver el patrón exacto que estaba repitiendo. Hoy hace 3 meses que no le hablo y por primera vez siento paz.'
  }, {
    name: 'Carolina',
    age: 34,
    city: 'Córdoba',
    img: 'https://randomuser.me/api/portraits/women/42.jpg',
    text: "Pensé que era amor, pero era pura dependencia. Leer 'La mujer que se elige' fue un balde de agua fría necesario. Me ayudó a ponerme como prioridad sin sentir culpa."
  }, {
    name: 'Micaela',
    age: 26,
    city: 'Rosario',
    img: 'https://randomuser.me/api/portraits/women/65.jpg',
    text: 'La ansiedad de esperar un mensaje me estaba consumiendo. Los módulos son súper prácticos. No es solo teoría, te da las herramientas para cortar el ciclo de verdad.'
  }, {
    name: 'Luciana',
    age: 31,
    city: 'Mendoza',
    img: 'https://randomuser.me/api/portraits/women/24.jpg',
    text: "Estaba agotada de mendigar atención. El bono de 'Estándares nuevos' me cambió la cabeza. Ahora sé lo que valgo y no acepto menos. Totalmente recomendado."
  }, {
    name: 'Romina',
    age: 39,
    city: 'La Plata',
    img: 'https://randomuser.me/api/portraits/women/51.jpg',
    text: 'Llevaba años en relaciones tóxicas. Este material me hizo entender que el problema era que yo me abandonaba. Hoy me elijo todos los días. Gracias.'
  }];
  return <section className="py-8 md:py-10 px-3 md:px-4 bg-dark" data-id="element-280">
      <div className="max-w-5xl mx-auto" data-id="element-281">
        <h2 className="text-3xl font-black text-white text-center uppercase mb-8" data-id="element-282">
          Ellas ya <span className="text-rosa" data-id="element-283">se eligieron</span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-284">
          {testimonials.map((t, idx) => <div key={idx} className="bg-black border border-white/5 p-5 rounded-xl flex flex-col" data-id="element-285">
              <div className="flex gap-1 mb-3" data-id="element-286">
                {[...Array(5)].map((_, i) => <Star key={i} size={14} className="text-terracota fill-terracota" data-id="element-287" />)}
              </div>
              <p className="text-gray-300 text-sm italic mb-4 flex-grow" data-id="element-288">
                "{t.text}"
              </p>
              <div className="flex items-center gap-3 mt-auto pt-4 border-t border-white/10" data-id="element-289">
                <img src={t.img} alt={t.name} className="w-10 h-10 rounded-full object-cover border border-rosa" data-id="element-290" />
                <div data-id="element-291">
                  <p className="text-white font-bold text-sm" data-id="element-292">
                    {t.name}, {t.age}
                  </p>
                  <p className="text-gray-500 text-xs" data-id="element-293">{t.city}, Argentina</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}